import React from 'react';
import { Link } from "react-router-dom";
import Api from "../../servicios/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleLeft, faAngleDoubleRight, faAngleRight, faFilter, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import { currencyFormat } from '../../js/Functions';
import * as XLSX from 'xlsx';

class Listar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datosCargados: false,
            load: '',
            atenciones: [],
            pagina: [],
            total: 0,
            totaltf: 0,
            registros: 0,
            sin_f: 0,
            con_f: 0,
            Precio: 0,
            Liq: 0,
            empresas: [],currentYear: new Date().getFullYear().toString(),
        };
    }

    cargarEmpresas() {
        fetch(Api + "Empresas")
            .then(respuesta => respuesta.json())
            .then((datosEmpresas) => {
                this.setState({ empresas: datosEmpresas.data });
            })
            .catch(console.log);
    }

    Buscar(page) {
        this.setState({ Precio: 0, total: 0, registros: 0, sin_f: 0, con_f: 0, atenciones: [] });
        let bano = document.getElementById('bano').value;
        let bmes = document.getElementById('bmes').value;
        let bate = document.getElementById('bate').value;
        let brev = document.getElementById('brev').value;
        let bpor = document.getElementById('bpor').value;
  
        if (bano === '') {
            bano = 0;
        }
        if (bmes === '') {
            bmes = 0;
        }
        if (bate === '') {
            bate = 0;
        }
        if (brev === '') {
            brev = 0;
        }
       

        Swal.showLoading();
        this.setState({ load: 'Cargando Datos...' });
        fetch(Api + "Auditoria/InformeFinanciero3/" + bano + "/" + bmes + "/" + bate + "/" + brev + "/" + bpor)
            .then((respuesta) => respuesta.json())
            .then((datosRespuesta) => {
                Swal.close();
                this.setState({ datosCargados: true, load: '', atenciones: datosRespuesta.datos, totaltf: datosRespuesta.total_factura, total: datosRespuesta.total, registros: datosRespuesta.registro });
            })
            .catch(console.log);
    }

    exportToExcel() {
        const { atenciones } = this.state;
        const headers = [
            "ITEM",
            "FECHA REGISTRO",
            "ESTADO",
            "COMPLETADA",
            "REVISADA",
            "PACIENTE",
            "EPS",
            "ORDEN_EXTERNA",
            "ORDEN_SERVICIO",
            "ATENCIÓN",
            "CANT. ATENCIONES",
            "PRECIO ATENCION",
            "TOTAL"
        ];
        const data = atenciones.map((itemAtenciones, i) => ({
            "ITEM": i + 1,
            "FECHA REGISTRO": itemAtenciones.fecha_reg_ta,
            "ESTADO": itemAtenciones.estado,
             "PACIENTE": itemAtenciones.nombres +' '+itemAtenciones.apellidos,
             "EPS": itemAtenciones.nombre_emp,
              "ORDEN_EXTERNA": itemAtenciones.orden_externa,
            "ORDEN_SERVICIO": itemAtenciones.orden_servicio,
            "COMPLETADA": itemAtenciones.id_contacto,
            "REVISADA": itemAtenciones.Location,
            "ATENCIÓN": itemAtenciones.Description,
            "CANT. ATENCIONES": itemAtenciones.cant,
            "PRECIO ATENCION": currencyFormat(itemAtenciones.precio_total),
            "TOTAL": currencyFormat(itemAtenciones.precio_total * itemAtenciones.cant)
        }));
        const worksheet = XLSX.utils.json_to_sheet(data, { header: headers });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Atenciones");
        XLSX.writeFile(workbook, "InformeFinancieroFacturacion.xlsx");
    }

    componentDidMount() {
        this.cargarEmpresas();
    }

    render() {
        const { datosCargados, load, atenciones, pagina, registros, total, sin_f, con_f, Precio, registro, totaltf,currentYear } = this.state;
        return (
            <div className="content">
                <div className="content-wrapper">
                    <div className="content">
                        <div className="container-fluid">
                            <div className="card">
                                <div className="card-header">
                                    &nbsp;
                                </div>
                                <div className="card-body">
                                    <h4>Ordenes sin facturar</h4>
                                    <div className="row">
                                        <div className="col-xl-1">
                                            <input type="text" id="bano" name="bano" placeholder="Año"  defaultValue={currentYear} className="form-control form-control-sm" maxLength="4" />
                                        </div>
                                        <div className="col-xl-2">
                                            <select className="form-select form-select-sm" type="text" name="bmes" id="bmes">
                                                <option value="">Seleccione el Mes</option>
                                                <option value="01">01 - Enero</option>
                                                <option value="02">02 - Febrero</option>
                                                <option value="03">03 - Marzo</option>
                                                <option value="04">04 - Abril</option>
                                                <option value="05">05 - Mayo</option>
                                                <option value="06">06 - Junio</option>
                                                <option value="07">07 - Julio</option>
                                                <option value="08">08 - Agosto</option>
                                                <option value="09">09 - Septiembre</option>
                                                <option value="10">10 - Octubre</option>
                                                <option value="11">11 - Noviembre</option>
                                                <option value="12">12 - Diciembre</option>
                                            </select>
                                        </div>
                                      
                                        
                                        <div className="col-xl-2">
                                            <input type="text" id="bate" name="bate" placeholder="Nombre de la atencion" className="form-control form-control-sm" />
                                        </div>
                                        <div className="col-xl-2">
                                            <input type="number" id="bpor" defaultValue={100} name="bpor" placeholder="Buscar por % " className="form-control form-control-sm" />
                                        </div>
                                        <div className="col-xl-2">
                                            <select className="form-select form-select-sm" type="text" name="brev" id="brev">
                                                <option value="0">Todas las atenciones</option>
                                                <option value="Revisado">Revisadas</option>

                                            </select>
                                        </div>
                                        <div className="col-xl-1">
                                            <button id="bt" name="bt" className="btn btn-primary btn-sm" onClick={() => this.Buscar(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                        </div>
                                        <div className='col-xl-2'>
                                            {
                                                datosCargados ? (
                                                    <button style={{ color: '#FFFFFF' }} id="btn_exportar" name="btn_exportar" onClick={() => this.exportToExcel()} className="btn btn-info btn-sm"><FontAwesomeIcon icon={faFileDownload} />&nbsp;&nbsp;Exportar</button>
                                                ) : null
                                            }
                                        </div>
                                    </div>
                                    <br></br>
                                    <div className="row">
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th>ITEM</th>
                                                    <th>FECHA REGISTRO</th>
                                                    <th>ESTADO</th>
                                                    <th>PORCENTAJE</th>
                                                    <th>REVISADA</th>
                                                    <th>PACIENTE</th>
                                                    <th>EPS</th>
                                                    <th>AUTORIZACION</th>
                                                    <th>ORDEN_SERVICIO</th>
                                                    <th>ATENCIÓN</th>
                                                    <th>CANT. ATENCIONES</th>
                                                    <th>PRECIO ATENCION</th>
                                                    <th>EST FACTURA</th>
                                                    <th>VLR UND</th>
                                                    <th>TOTAL</th>
                                       
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {load}
                                                {atenciones.map((itemAtenciones, i) => (
                                                    <tr key={i}>
                                                        <td>{i + 1}</td>
                                                        <td>{itemAtenciones.fecha_reg_ta}</td>
                                                        <td>{itemAtenciones.estado}</td>
                                                        <td>{itemAtenciones.id_contacto}%</td>
                                                        <td>{itemAtenciones.Location}</td>
                                                        <td>{itemAtenciones.nombres} {itemAtenciones.apellidos}</td>
                                                        <td>{itemAtenciones.nombre_emp}</td>
                                                        <td>{itemAtenciones.orden_externa}</td>
                                                        <td>{itemAtenciones.orden_servicio}</td>
                                                        <td>{itemAtenciones.Description}</td>
                                                        <td>{itemAtenciones.cant}</td>
                                                        <td>{itemAtenciones.prioridad}</td>
                                                        <td>{itemAtenciones.relacionado}</td>
                                                        <td>{currencyFormat(itemAtenciones.precio_total)}</td>
                                                        <td>{currencyFormat(itemAtenciones.precio_total * itemAtenciones.cant)}</td>
                                                       
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tr>
                                                <td colSpan={12}></td>
                                                <td>Totales</td>
                                                <td>{currencyFormat(totaltf)}</td>
                                        
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                                <div className="card-footer text-muted">
                                    <b>Total de registros: </b> <span className="badge bg-primary">{registros}</span> <b>--</b>Total de Atenciones: <span className="badge bg-success">{currencyFormat(total)}</span>  

                                    | Total sin Facturar : <span className="badge bg-warning">{currencyFormat(totaltf)} </span> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;
